import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { providerInitialValues } from 'components/organisms/forms/providers/ProviderForm';
import { useCustomParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetProvider, usePutProvider } from 'services/providers';
import { IProviderForm } from 'services/providers/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const EditProvider = () => {
  const providerId = useCustomParamId('id', '/provider');
  const { t } = useTranslation();
  const navigate = useNavigate();

  const provider = useGetProvider(providerId);
  const updateProvider = usePutProvider();

  const goToDetail = () => navigate(`/settings/provider/${providerId}`);

  const onUpdateProvider = async (values: IProviderForm) => {
    await updateProvider.mutateAsync(
      { ...middleware.provider.formToQuery(values), id: providerId },
      {
        onError: error => onErrorShowAllErrorsToast(error),
        onSuccess: goToDetail,
      }
    );
  };

  return (
    <Form.Provider
      customBackItem={
        <Button type='button' onlyIcon onClick={goToDetail}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.save')} />
        </Button>
      }
      onSubmit={onUpdateProvider}
      initialValues={
        provider.data
          ? middleware.provider.queryToForm(provider.data)
          : providerInitialValues
      }
      i18nextPrefix='provider'
      status={{ isLoading: provider.isLoading }}
    />
  );
};

export default EditProvider;
